<app-spinner *ngIf="loading"></app-spinner>

<div *ngIf="!loading" fxLayout="row" fxLayoutAlign="center start" fxLayoutGap="30px">
    <div class="add-btn">
        <button [disabled]="id === 'new'" mat-raised-button aria-label="" (click)="sendEmail($event)">
                <mat-icon>flight_takeoff</mat-icon>
                <mat-icon>flight</mat-icon>
                <mat-icon class="icon-flipped">flight_takeoff</mat-icon>
        </button>
    </div>
    <mat-card>
        <mat-card-header>
            <mat-card-title>{{ title }}</mat-card-title>
        </mat-card-header>
        <mat-card-content>
            <form [formGroup]="emailForm" (submit)="onSubmit()">
                <mat-form-field>
                    <input matInput formControlName="name" placeholder="{{'NEW-MAILERS.NAME' | translate}}">
                </mat-form-field>

                <div fxLayout="row" fxLayoutAlign="start start" fxLayoutGap="30px">
                    <mat-form-field>
                        <input matInput formControlName="subject" placeholder="{{'NEW-MAILERS.SUBJECT' | translate}}">
                    </mat-form-field>
                    <mat-form-field>
                        <input matInput placeholder="{{'NEW-MAILERS.FROM-NAME' | translate}}" formControlName="fromName">
                    </mat-form-field>
                    <mat-form-field>
                        <input matInput placeholder="{{'NEW-MAILERS.FROM-EMAIL' | translate}}" formControlName="fromEmail">
                    </mat-form-field>

                </div>


                <div fxLayout="row" fxLayoutAlign="start start" fxLayoutGap="30px">
                    <mat-form-field>
                        <input type="text" placeholder="{{'NEW-MAILERS.CHOOSE-SITE' | translate}}" matInput formControlName="siteId"
                            [matAutocomplete]="siteAuto">
                        <mat-autocomplete autoActiveFirstOption #siteAuto="matAutocomplete" [displayWith]="siteForId">
                            <mat-option *ngFor="let site of siteList" [value]="site._id">
                                {{ site.name }}
                            </mat-option>
                        </mat-autocomplete>
                    </mat-form-field>


                    <mat-form-field>
                        <input type="text" placeholder="{{'NEW-MAILERS.CHOOSE-MAILING-LIST' | translate}}" matInput formControlName="maillistId"
                            [matAutocomplete]="maillistAuto">
                        <mat-autocomplete autoActiveFirstOption #maillistAuto="matAutocomplete"
                            [displayWith]="maillistForId">
                            <mat-option *ngFor="let maillist of maillistList" [value]="maillist._id">
                                {{ maillist.toString() }}
                            </mat-option>
                        </mat-autocomplete>
                    </mat-form-field>
                </div>
                <div fxLayout="row"  fxLayoutGap="30px">
                    <mat-form-field>
                        <input matInput placeholder="Sendgrid API Key" formControlName="sendgridApiKey">
                    </mat-form-field>
                    <mat-form-field>
                        <input matInput formControlName="sitePath" placeholder="{{'NEW-MAILERS.LINK-END' | translate}}">
                    </mat-form-field>
                </div>
                <div style="display: flex;align-items: center;">
                    <div>{{'NEW-MAILERS.LINK' | translate}} {{ siteLink }}</div>
                    <button mat-icon-button style="color: grey;" [cdkCopyToClipboard]="siteLink"
                        (click)="$event.stopImmediatePropagation(); $event.preventDefault()">
                        <mat-icon>content_copy</mat-icon>
                    </button>
                </div>

                <vzn-media-files
                    uploadFolder="attachments"
                    [maxImageSize]="900"
                    width='auto'
                    height='100px'
                    assetMargin='5px'
                    [uploadUrlService]="uploadUrlService"
                    formArrayName='attachments'
                    [multiple]="true"
                    acceptedFiles="*"
                ></vzn-media-files>
                
                <app-editor [formGroup]="emailForm" inputName="body" htmlInputName="htmlCode"></app-editor>

                <div class="form-row" fxLayout="row"  fxLayoutGap="30px">
                    <mat-form-field>
                        <input matInput placeholder="{{'NEW-MAILERS.SMS-FROM-NAME' | translate}}" formControlName="smsFrom">
                        <mat-error *ngIf="emailForm.get('smsFrom')?.hasError('maxlength')">אורך מקסימלי 11 תוים!</mat-error>
                        <mat-error *ngIf="emailForm.get('smsFrom')?.hasError('pattern')">ניתן להשתמש רק באותיות באנגלית</mat-error>
                    </mat-form-field>
                </div>

                <mat-form-field>
                    <textarea matInput formControlName="smsContent" placeholder="{{'NEW-MAILERS.SMS-CONTENT' | translate}}" cdkTextareaAutosize cdkAutosizeMinRows="5"></textarea>
                </mat-form-field>
            </form>


            <div class="card-footer" style="display: flex;align-items: center;justify-content: space-between;">
                <button mat-raised-button color="primary" type="submit" (click)="onSubmit()">{{'NEW-MAILERS.SAVE' | translate}}</button>

                <div style="display: flex;align-items: center;">
                    <mat-form-field>
                        <input matInput [formControl]="testEmailAddress" placeholder="{{'NEW-MAILERS.EMAIL-ADRESS-CHECK' | translate}}">
                    </mat-form-field>
                    <button class="icon-flipped" mat-icon-button style="color: grey;" [cdkCopyToClipboard]="siteLink"
                        (click)="sendPreviewEmail()">
                        <mat-icon>send</mat-icon>
                    </button>
                </div>
            </div>

        </mat-card-content>
    </mat-card>
</div>